export default "__VITE_ASSET__DdPtpmuq__"